import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  HStack,
  Heading,
  Divider,
  SimpleGrid,
  useColorModeValue,
  IconButton,
  Collapse,
  useDisclosure,
} from '@chakra-ui/react';
import { SearchIcon, ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

export default function InvoiceFilters({ onSearch, isLoading = false }) {
  const { isOpen, onToggle } = useDisclosure();
  const [filters, setFilters] = useState({
    customer: '',
    document: '',
    invoiceNumber: '',
    startDate: '',
    endDate: '',
  });

  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const handleChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = () => {
    // Filtrar campos vacíos antes de enviar
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value && value.trim() !== '')
    );
    console.log('Sending filters from component:', cleanFilters);
    onSearch(cleanFilters);
  };

  const handleClear = () => {
    setFilters({
      customer: '',
      document: '',
      invoiceNumber: '',
      startDate: '',
      endDate: '',
    });
    console.log('Clearing filters');
    onSearch({}); // Buscar sin filtros (obtener todas)
  };

  const hasFilters = Object.values(filters).some(value => value && value.trim() !== '');

  return (
    <Box 
      p={4} 
      borderWidth={1} 
      borderRadius="lg" 
      bg={cardBg}
      borderColor={borderColor}
      mb={4}
    >
      <HStack justify="space-between" align="center" mb={isOpen ? 4 : 0}>
        <Heading size="sm" color="gray.600">
          Filtros de Búsqueda
        </Heading>
        <IconButton
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          size="sm"
          variant="ghost"
          onClick={onToggle}
        />
      </HStack>

      <Collapse in={isOpen} animateOpacity>
        <VStack spacing={4} align="stretch">
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
            <FormControl>
              <FormLabel fontSize="sm">Cliente</FormLabel>
              <Input
                placeholder="Nombre del cliente"
                value={filters.customer}
                onChange={(e) => handleChange('customer', e.target.value)}
                size="sm"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Documento</FormLabel>
              <Input
                placeholder="Documento del cliente"
                value={filters.document}
                onChange={(e) => handleChange('document', e.target.value)}
                size="sm"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">N° de Factura</FormLabel>
              <Input
                placeholder="Número de factura"
                value={filters.invoiceNumber}
                onChange={(e) => handleChange('invoiceNumber', e.target.value)}
                size="sm"
              />
            </FormControl>
          </SimpleGrid>

          <Divider />
          
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <FormControl>
              <FormLabel fontSize="sm">Fecha desde</FormLabel>
              <Input
                type="date"
                value={filters.startDate}
                onChange={(e) => handleChange('startDate', e.target.value)}
                size="sm"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Fecha hasta</FormLabel>
              <Input
                type="date"
                value={filters.endDate}
                onChange={(e) => handleChange('endDate', e.target.value)}
                size="sm"
              />
            </FormControl>
          </SimpleGrid>

          <HStack justify="flex-end" spacing={3}>
            <Button
              size="sm"
              variant="outline"
              onClick={handleClear}
              isDisabled={!hasFilters || isLoading}
            >
              Limpiar
            </Button>
            <Button
              size="sm"
              colorScheme="gray"
              leftIcon={<SearchIcon />}
              onClick={handleSearch}
              isLoading={isLoading}
              loadingText="Buscando..."
            >
              Aplicar filtros
            </Button>
          </HStack>
        </VStack>
      </Collapse>
    </Box>
  );
}